module.exports = __webpack_public_path__ + "cd2b8a0cd1a15a2366e2057ce6639a03.jpg";